(function () {
  'use strict';

  angular
      .module('tfc.Reports')
      .controller('CategoryReportsCtrl', CategoryReportsCtrl);

  // @ngInject
  function CategoryReportsCtrl($state, $stateParams, reports, ReportUtil, ProgressModal, GaUtil, BrandReports, PageSize,
                               Reports, reportsCount, defaultTla, Toast) {
    var vm = this;

    vm.category = $state.$current.data && $state.$current.data.reportCategory;

    vm.reports = ReportUtil.sort(reports);
    vm.currentPage = 1;
    vm.pageSize = PageSize;
    vm.maxSize = 7;
    vm.reportCount = reportsCount.count;

    vm.fileType = ReportUtil.fileType;
    vm.reportIcon = ReportUtil.reportIcon;
    vm.openReport = ReportUtil.openReport;

    vm.downloadReport = function (report) {
      return BrandReports.selectedBrandKey($stateParams.brandKey).then(function(selectedBrandKey) {
        var brandKey = selectedBrandKey;
        GaUtil.sendGaEvent(brandKey, 'Download Report', 'Download ' + vm.category + ' report');
        ProgressModal.showModal(ReportUtil.downloadReport(report), {
          translationKey : 'reports.loading',
          progress : false
        }).then(null, function(error){
          Toast.error('reports.failed', { state : true });
        });
      });
    };

    vm.pageChange = function(currentPage){
      return Reports.find(defaultTla, vm.category, $stateParams.year, vm.pageSize, currentPage).then(function (reports) {
        vm.currentPage = currentPage;
        vm.reports = reports;
      });
    };
  }

})();